import React from 'react'
import { ArbeitszeitGesamtRow } from '@myapp/contract'
import { DataTable, TableColumn } from '../../../../shared/ui'
import { GESAMT_CATEGORY_LABELS } from '../model/constants'

function fmtNum(n: number): string {
  return n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

function fmtPct(n: number): string {
  return `${n >= 0 ? '+' : ''}${n.toLocaleString('de-DE', { minimumFractionDigits: 1, maximumFractionDigits: 1 })} %`
}

const COLUMNS: TableColumn<ArbeitszeitGesamtRow>[] = [
  {
    key: 'category',
    header: 'Kategorie',
    render: (r) => (
      <span className={r.category === 'gesamt' ? 'font-semibold text-[#004494]' : 'text-[#004494]'}>
        {GESAMT_CATEGORY_LABELS[r.category]}
      </span>
    ),
  },
  {
    key: 'sollStd',
    header: 'SOLL (Std.)',
    headerClassName: 'min-w-[140px] text-center',
    cellClassName: 'text-center whitespace-nowrap',
    render: (r) =>
      r.sollStd != null ? (
        <span className={r.category === 'gesamt' ? 'font-semibold' : ''}>{fmtNum(r.sollStd)}</span>
      ) : (
        <span className="text-gray-400">–</span>
      ),
  },
  {
    key: 'istStd',
    header: 'IST (Std.)',
    headerClassName: 'min-w-[140px] text-center',
    cellClassName: 'text-center whitespace-nowrap',
    render: (r) => (
      <span className={r.category === 'gesamt' ? 'font-semibold' : ''}>{fmtNum(r.istStd)}</span>
    ),
  },
  {
    key: 'abweichungStd',
    header: 'Abweichung',
    headerClassName: 'min-w-[140px] text-center',
    cellClassName: 'text-center whitespace-nowrap',
    render: (r) =>
      r.abweichungStd != null ? (
        <span className={r.category === 'gesamt' ? 'font-semibold' : ''}>
          {r.abweichungStd >= 0 ? '+' : ''}
          {fmtNum(r.abweichungStd)}
        </span>
      ) : (
        <span className="text-gray-400">–</span>
      ),
  },
  {
    key: 'abweichungPct',
    header: '%',
    headerClassName: 'min-w-[110px] text-center',
    cellClassName: 'text-center whitespace-nowrap',
    render: (r) =>
      r.abweichungPct != null ? (
        <span className={r.category === 'gesamt' ? 'font-semibold' : ''}>{fmtPct(r.abweichungPct)}</span>
      ) : (
        <span className="text-gray-400">–</span>
      ),
  },
  {
    key: 'wertEuro',
    header: 'Wert (€)',
    headerClassName: 'min-w-[110px] text-center',
    cellClassName: 'text-center',
    render: () => <span className="text-gray-400">–</span>,
  },
]

interface GesamtuebersichtTableProps {
  rows: ArbeitszeitGesamtRow[]
  isLoading?: boolean
  isFetching?: boolean
}

export const GesamtuebersichtTable: React.FC<GesamtuebersichtTableProps> = ({
  rows,
  isLoading,
  isFetching,
}) => (
  <DataTable<ArbeitszeitGesamtRow>
    columns={COLUMNS}
    rows={rows}
    getRowKey={(r) => r.category}
    isLoading={isLoading}
    isFetching={isFetching}
    emptyMessage="Keine Daten"
    compact
    minWidth={700}
  />
)
